import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/node_modules/.pnpm/next@15.5.25_@types+node@22.19.18_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
